import { useCallback, useState } from 'react';
import { useTranslation } from '../i18n';
const getPlaceholder = _ref => {
  let {
    t,
    hasTokens,
    showSearch
  } = _ref;
  if (hasTokens) {
    // Token controls with tokens should not show placeholders
    return '';
  }
  return showSearch ? t('SEARCH') : t('SELECT');
};
export default (_ref2 => {
  let {
    placeholderProp,
    hasTokens,
    isOpen,
    disabled,
    openMenu
  } = _ref2;
  const {
    t
  } = useTranslation();
  const [isInputFocused, setInputFocused] = useState(false);
  const placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : getPlaceholder({
    t,
    hasTokens,
    showSearch: isOpen || isInputFocused
  });
  const onFocus = useCallback(() => setInputFocused(true), []);
  const onBlur = useCallback(() => setInputFocused(false), []);
  const onContainerClick = useCallback(() => {
    !isOpen && !disabled && (openMenu === null || openMenu === void 0 ? void 0 : openMenu());
  }, [disabled, isOpen, openMenu]);
  return {
    containerProps: {
      isOpen,
      isAutocomplete: true,
      disabled,
      onClick: onContainerClick
    },
    searchInputProps: {
      isOpen,
      disabled,
      placeholder,
      onFocus,
      onBlur,
      showIcon: !hasTokens && (isOpen || isInputFocused)
    }
  };
});
//# sourceMappingURL=useAutocompleteControl.js.map